import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, AfterViewInit, Input, ElementRef, ViewChild } from '@angular/core';
import { ModalController, ItemReorderEventDetail } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { Utils } from 'src/app/api/helper/utils';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { AuftragListItem } from 'src/app/api/model/model';
import { AuftragService } from 'src/app/api/auftrag.service';
import L, { Map, TileLayer, Marker, MarkerOptions, Icon, LatLngBounds, LatLng, Polyline, DivIcon } from 'leaflet';
import { SystemService } from 'src/app/api/system.service';
import { KarteWidgetComponent } from 'src/app/shared/components/karte-widget/karte-widget.component';

const log = new Logger('AuftragSortierenPage');

@Component({
    selector: 'app-auftrag-sortieren',
    templateUrl: './auftrag-sortieren.page.html',
    styleUrls: ['./auftrag-sortieren.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragSortierenPage implements OnInit, OnDestroy, AfterViewInit {
    private subscriptions: Subscription[] = [];

    app = MyApp.current;

    @Input() auftraege: AuftragListItem[];

    minItemHeight = undefined;
    approxItemHeight = undefined;
    isVisible = false;

    geaendert = false;

    map: L.Map;
    markers: L.Marker[] = [];
    lines: any[] = [];

    constructor(
        private auftragService: AuftragService,
        private systemService: SystemService,
        private modalController: ModalController) {

    }

    async ngOnInit() {
        log?.debug('ngOnInit start');

        this.minItemHeight = MyApp.current.auftragZeilenhoeheMin + 'px';
        this.approxItemHeight = this.minItemHeight;

        this.isVisible = true;
    }

    async ngAfterViewInit() {
        // this.cdr.detach();
    }

    async ionViewWillEnter() {
        log?.debug('ionViewWillEnter');
    }

    async ionViewDidEnter() {
        try {
            log?.debug('ionViewDidEnter');

        } catch (err) {
            log.error('ionViewDidEnter: ' + Utils.getErrorMessage(err));
        }
    }

    ionViewWillLeave() {
        try {
            log?.debug('ionViewWillLeave');

            if (this.geaendert) {
                this.speichern();
            }

        } catch (err) {
            log.error('ionViewWillLeave: ' + Utils.getErrorMessage(err));
        }
    }

    async speichern() {
        if (!this.auftraege) {
            return;
        }

        let listItems = this.auftraege.filter(p => p.manuelleReihenfolge > 0);

        for (const listItem of listItems) {
            const auftrag = await this.auftragService.getAuftrag(listItem.Key, false, false);

            if (auftrag) {
                auftrag.manuelleReihenfolge = listItem.manuelleReihenfolge;

                await this.auftragService.speichereAuftrag(auftrag, {
                    listItemAktualisieren: false
                });
            }
        }

        await this.auftragService.speichereAuftragListItems();
    }

    async ngOnDestroy() {
        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        this.isVisible = false;
    }

    handleReorder(ev: CustomEvent<ItemReorderEventDetail>) {
        // The `from` and `to` properties contain the index of the item
        // when the drag started and ended, respectively
        log?.debug('Dragged from index ' + ev.detail.from + ' to ' + ev.detail.to);

        // Finish the reorder and position the item in the DOM based on
        // where the gesture ended. This method can also be called directly
        // by the reorder group
        this.auftraege = ev.detail.complete(this.auftraege);

        let from = ev.detail.from;
        let to = ev.detail.to;

        setTimeout(() => {
            // Setze die manuelle Reihenfolge auf Werte > 0
            // Die Reihenfolge wird anschließend komplett neu berechnet
            this.auftraege[from].manuelleReihenfolge = 1;
            this.auftraege[to].manuelleReihenfolge = 1;

            let minIdx = -1;
            let maxIdx = -1;

            // Suche noch einmal alle Indizes mit geänderten manuellen Reihenfolgen.
            for (let i = 0; i < this.auftraege.length; i++) {
                let listItem = this.auftraege[i];

                if (listItem.manuelleReihenfolge > 0) {
                    if (minIdx === -1) {
                        minIdx = i;
                    }

                    maxIdx = i;
                }
            }

            // Setze die manuelle Reihenfolge für alle Aufträge und alle dazwischen
            for (let i = minIdx; i <= maxIdx; i++) {
                let listItem = this.auftraege[i];
                listItem.manuelleReihenfolge = (i + 1);

                log?.debug(`Manuelle Reihenfolge ${listItem.Auftragsnummer}: ${listItem.Reihenfolge} => ${listItem.manuelleReihenfolge}`);
            }

            this.geaendert = true;
        });
    }

    async onClose() {
        if (this.isVisible) {
            this.dismiss();
        }
    }

    dismiss() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.modalController.dismiss({
            'dismissed': true
        });
    }
}
